import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Buttons } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Buttons";
import { ButtonStyles } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Buttons/ButtonStyles";
import { Colors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Colors";
import { Styles } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Styles";
import { Text } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Text";
import { TextStyles } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Text/TextStyles";
import { DefaultSiteThemesView } from "./DefaultSiteThemesView";

interface ComponentMapItem {
  content: ReactNode;
  title: string;
}

export const themeComponentMap: Record<string, ComponentMapItem> = {
  siteThemeList: {
    title: t("builder_ui.theme_configuration.site_themes.title"),
    content: <DefaultSiteThemesView />,
  },
  buttonStyles: {
    title: t("builder_ui.theme_configuration.site_styles.token_types.buttons"),
    content: <Buttons />,
  },
  textStyles: {
    title: t("builder_ui.theme_configuration.site_styles.token_types.text"),
    content: <Text />,
  },
  siteColorsList: {
    title: t("builder_ui.theme_configuration.site_styles.token_types.colors"),
    content: <Colors />,
  },
  siteStyles: {
    title: t("builder_ui.theme_configuration.site_styles.token_types.styles"),
    content: <Styles />,
  },
  h1TextStyles: {
    title: t("builder_ui.block_type.h1"),
    content: <TextStyles />,
  },
  h2TextStyles: {
    title: t("builder_ui.block_type.h2"),
    content: <TextStyles />,
  },
  h3TextStyles: {
    title: t("builder_ui.block_type.h3"),
    content: <TextStyles />,
  },
  h4TextStyles: {
    title: t("builder_ui.block_type.h4"),
    content: <TextStyles />,
  },
  h5TextStyles: {
    title: t("builder_ui.block_type.h5"),
    content: <TextStyles />,
  },
  h6TextStyles: {
    title: t("builder_ui.block_type.h6"),
    content: <TextStyles />,
  },
  p1TextStyles: {
    title: t("builder_ui.block_type.p1"),
    content: <TextStyles />,
  },
  p2TextStyles: {
    title: t("builder_ui.block_type.p2"),
    content: <TextStyles />,
  },
  p3TextStyles: {
    title: t("builder_ui.block_type.p3"),
    content: <TextStyles />,
  },
  primaryButton: {
    title: t("builder_ui.block_type.primary_button"),
    content: <ButtonStyles />,
  },
  secondaryButton: {
    title: t("builder_ui.block_type.secondary_button"),
    content: <ButtonStyles />,
  },
};
